import './products-section.scss';

export default function ProductsSection() {
    return(
        <div className="sv-products-section">
            <div className="sv-products-section-grid">
                <div className="sv-products-section-grid-header">
                    <span>coming <span>soon</span></span>
                </div>
                <div className="sv-products-section-grid-content">
                    <div className="sv-products-section-grid-content-wrapper">
                        <div className="sv-products-section-grid-content-wrapper-box">
                            <div>
                                <table className="sv-products-section-grid-content-innerTable">
                                    <tr className="sv-products-section-grid-content-innerTable-row">
                                        <td className="sv-products-section-grid-content-innerTable-quad1">
                                            <div className="sv-products-box" />
                                        </td>
                                        <td className="sv-products-section-grid-content-innerTable-quad2">
                                            Random pick
                                        </td>
                                    </tr>
                                    <tr className="sv-products-section-grid-content-blank-row-s" />
                                    <tr className="sv-products-section-grid-content-innerTable-row">
                                        <td className="sv-products-section-grid-content-innerTable-quad3">
                                        </td>
                                        <td className="sv-products-section-grid-content-innerTable-quad4">
                                            This provides you with the opportunity to pick your own card with a question in mind.  The card will reveal an image with symbols and the traditional meanings associated with it.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <table className="sv-products-section-grid-content-innerTable">
                                    <tr className="sv-products-section-grid-content-innerTable-row">
                                        <td className="sv-products-section-grid-content-innerTable-quad1">
                                            <div className="sv-products-box" />
                                        </td>
                                        <td className="sv-products-section-grid-content-innerTable-quad2">
                                            Numerology
                                        </td>
                                    </tr>
                                    <tr className="sv-products-section-grid-content-blank-row-s" />
                                    <tr className="sv-products-section-grid-content-innerTable-row">
                                        <td className="sv-products-section-grid-content-innerTable-quad3">
                                        </td>
                                        <td className="sv-products-section-grid-content-innerTable-quad4">
                                            Numerology reveals insights into your personality and life path through the significant vibrations of numbers.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <table className="sv-products-section-grid-content-innerTable">
                                    <tr className="sv-products-section-grid-content-innerTable-row">
                                        <td className="sv-products-section-grid-content-innerTable-quad1">
                                            <div className="sv-products-box" />
                                        </td>
                                        <td className="sv-products-section-grid-content-innerTable-quad2">
                                            Sound therapy
                                        </td>
                                    </tr>
                                    <tr className="sv-products-section-grid-content-blank-row-s" />
                                    <tr className="sv-products-section-grid-content-innerTable-row">
                                        <td className="sv-products-section-grid-content-innerTable-quad3">
                                        </td>
                                        <td className="sv-products-section-grid-content-innerTable-quad4">
                                            I offer personalised live sound therapy sessions designed to promote relaxation, healing and overall well-being.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <table className="sv-products-section-grid-content-innerTable">
                                    <tr className="sv-products-section-grid-content-innerTable-row">
                                        <td className="sv-products-section-grid-content-innerTable-quad1">
                                            <div className="sv-products-box" />
                                        </td>
                                        <td className="sv-products-section-grid-content-innerTable-quad2">
                                            Crystals
                                        </td>
                                    </tr>
                                    <tr className="sv-products-section-grid-content-blank-row-s" />
                                    <tr className="sv-products-section-grid-content-innerTable-row">
                                        <td className="sv-products-section-grid-content-innerTable-quad3">
                                        </td>
                                        <td className="sv-products-section-grid-content-innerTable-quad4">
                                            I aim to empower my customers on their wellness journeys by providing beautiful crystals along with knowledge on how to use them effectively.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}